import {StoreInventoryItems} from '../../../enums/StoreInventoryItems.js';

import coconut from './01_coconut_bomb.json' assert {type: 'json'};
import smasher from './02_fruit_smasher.json' assert {type: 'json'};
import barrier from './03_blob_barrier.json' assert {type: 'json'};
import clock from './04__clock_magnet.json' assert {type: 'json'};
import skull from './05__skull_smasher.json' assert {type: 'json'};
import nuke from './06__nuke.json' assert {type: 'json'};
import mushroom from './07__mushroom.json' assert {type: 'json'};

import rainbowfruit from './01_Rainbow_Fruit.json' assert {type: 'json'};
import tnt from './02_TNT.json' assert {type: 'json'};
import bonusBooster from './03_Bonus_Booster.json' assert {type: 'json'};
import cherryBonus from './04_Cherry_Bonus.json' assert {type: 'json'};
import starBooster from './05_Star_Booster.json' assert {type: 'json'};
import timeBonus from './06_Time_Bonus.json' assert {type: 'json'};

import bombDescription from './Bomb_Button.json' assert {type: 'json'};
import smasherDescription from './Fruit_Smasher_Button.json' assert {type: 'json'};
import barrierDescription from './Forcefield_Button.json' assert {type: 'json'};
import clockDescription from './Clock_Kill_Button.json' assert {type: 'json'};
import skullDescription from './Countdown_Kill_Button.json' assert {type: 'json'};
import nukeDescription from './Nuke_Button.json' assert {type: 'json'};
import mushroomDescription from './Mushroom_Popper_Button.json' assert {type: 'json'};

import rainbowfruitDescription from './Rainbow_Fruit_Increase_Button.json' assert {type: 'json'};
import tntDescription from './TNT_Increase_Button.json' assert {type: 'json'};
import bonusBoosterDescription from './Chain_Booster_Button.json' assert {type: 'json'};
import cherryBonusDescription from './Score_Multiplier_Button.json' assert {type: 'json'};
import starBonusDescription from './Add_Bonus_Countdown_Perk.json' assert {type: 'json'};
import timeBonusDescription from './Add_Time_Perk.json' assert {type: 'json'};

import {PowerupSelectItem} from './PowerupSelectItem.js';
import {PerkSelectItem} from './PerkSelectItem.js';

export class StorePowerupsData {
    private static _instance: StorePowerupsData;

    static get instance(): StorePowerupsData {
        if (!StorePowerupsData._instance) {
            StorePowerupsData._instance = new StorePowerupsData();
        }
        return StorePowerupsData._instance;
    }

    data: Map<StoreInventoryItems, PowerupSelectItem | PerkSelectItem> = new Map();
    descriptions: Map<StoreInventoryItems, PowerupLevelDescriptions> = new Map();

    supportedItems: StoreInventoryItems[] = [
        StoreInventoryItems.coconut,
        StoreInventoryItems.smasher,
        StoreInventoryItems.barrier,
        StoreInventoryItems.clock,
        StoreInventoryItems.skull,
        StoreInventoryItems.nuke,
        StoreInventoryItems.mushroom,

        StoreInventoryItems.rainbowPerk,
        StoreInventoryItems.tntPerk,
        StoreInventoryItems.chainBonusPerk,
        StoreInventoryItems.cherryBonusPerk,
        StoreInventoryItems.starBoosterPerk,
        StoreInventoryItems.addTimePerk,
    ];

    private constructor() {
        //TK: Temporary addition to mark as implemented.
        (coconut as PowerupSelectItem).isImplemented = true;
        (smasher as PowerupSelectItem).isImplemented = true;

        (rainbowfruit as PerkSelectItem).isImplemented = true;
        (tnt as PerkSelectItem).isImplemented = true;
        (bonusBooster as PerkSelectItem).isImplemented = true;

        this.data.set(StoreInventoryItems.coconut, coconut);
        this.data.set(StoreInventoryItems.smasher, smasher);
        this.data.set(StoreInventoryItems.barrier, barrier);
        this.data.set(StoreInventoryItems.clock, clock);
        this.data.set(StoreInventoryItems.skull, skull);
        this.data.set(StoreInventoryItems.nuke, nuke);
        this.data.set(StoreInventoryItems.mushroom, mushroom);

        this.data.set(StoreInventoryItems.rainbowPerk, rainbowfruit);
        this.data.set(StoreInventoryItems.tntPerk, tnt);
        this.data.set(StoreInventoryItems.chainBonusPerk, bonusBooster);
        this.data.set(StoreInventoryItems.cherryBonusPerk, cherryBonus);
        this.data.set(StoreInventoryItems.starBoosterPerk, starBooster);
        this.data.set(StoreInventoryItems.addTimePerk, timeBonus);

        this.descriptions.set(StoreInventoryItems.coconut, bombDescription);
        this.descriptions.set(StoreInventoryItems.smasher, smasherDescription);
        this.descriptions.set(StoreInventoryItems.barrier, barrierDescription);
        this.descriptions.set(StoreInventoryItems.clock, clockDescription);
        this.descriptions.set(StoreInventoryItems.skull, skullDescription);
        this.descriptions.set(StoreInventoryItems.nuke, nukeDescription);
        this.descriptions.set(StoreInventoryItems.mushroom, mushroomDescription);

        this.descriptions.set(StoreInventoryItems.rainbowPerk, rainbowfruitDescription);
        this.descriptions.set(StoreInventoryItems.tntPerk, tntDescription);
        this.descriptions.set(StoreInventoryItems.chainBonusPerk, bonusBoosterDescription);
        this.descriptions.set(StoreInventoryItems.cherryBonusPerk, cherryBonusDescription);
        this.descriptions.set(StoreInventoryItems.starBoosterPerk, starBonusDescription);
        this.descriptions.set(StoreInventoryItems.addTimePerk, timeBonusDescription);
    }
}
